import React, { useEffect } from 'react';
import { Card } from '../components/ui/card';
import { Phone, Mail, MapPin } from 'lucide-react';
import Header from '../components/Header';
import ContactForm from '../components/ContactForm';
import { useLanguage } from '../context/LanguageContext';

const Kontakt = () => {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white">
      {/* Header */}
      <Header />

      {/* Content */}
      <main className="container mx-auto px-4 py-12 max-w-6xl pt-28">
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">{t('contact.title')}</h1>
          <p className="text-lg text-gray-600">
            {t('contact.subtitle')}
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-8">
          {/* Contact Info */}
          <Card className="p-8 shadow-xl border-0 bg-white rounded-2xl">
            <h3 className="text-2xl font-semibold text-gray-900 mb-6 text-center">{t('contact.info')}</h3>
            <div className="space-y-6">
              {/* Telefon */}
              <div className="flex items-start gap-4">
                <Phone className="w-6 h-6 text-amber-600 mt-1 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-gray-900 mb-1">{t('contact.phone')}</p>
                  <a href="tel:+491621991199" className="text-amber-600 hover:text-amber-700 text-lg">
                    +49 162 199 1199
                  </a>
                </div>
              </div>
              
              {/* E-Mail */}
              <div className="flex items-start gap-4">
                <Mail className="w-6 h-6 text-amber-600 mt-1 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-gray-900 mb-1">{t('contact.email')}</p>
                  <a href="mailto:service@villa-thailand.com" className="text-amber-600 hover:text-amber-700 text-lg break-all">
                    service@villa-thailand.com
                  </a>
                </div>
              </div>
              
              {/* Adresse */}
              <div className="flex items-start gap-4">
                <MapPin className="w-6 h-6 text-amber-600 mt-1 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-gray-900 mb-1">{t('contact.address')}</p>
                  <p className="text-gray-700 leading-relaxed">
                    VILLA THAILAND<br/>
                    Pran Mountain View<br/>
                    Moo 7, Pranburi 168/87<br/>
                    77120 Pranburi<br/>
                    Prachuap Khiri Khan<br/>
                    THAILAND
                  </p>
                </div>
              </div>
            </div>
          </Card>
          
          {/* Contact Form */}
          <ContactForm />
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8 mt-16">
        <div className="container mx-auto px-4 text-center">
          <p className="text-gray-400">
            {t('footer.copyright')}
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Kontakt;
